export default __webpack_public_path__ + "static/media/areatoraise-two.da9b1a71.png";